module.exports = __webpack_public_path__ + "img/pd-img48.7ce8ac0e.jpg";